<div class="modal-header">
  <h4 class="modal-title">Invite Email Preview</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <style>
  </style>

  <div id="invite-email-container">

    <table class="body-wrap" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; width: 100%; background-color: #f6f6f6; margin: 0;" bgcolor="#f6f6f6"><tr style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; margin: 0;"><td style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; margin: 0;" valign="top"></td>
      <td class="container" width="600" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; vertical-align: top; display: block !important; max-width: 600px !important; clear: both !important; margin: 0 auto;" valign="top">
        <div class="content" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; max-width: 600px; display: block; margin: 0 auto; padding: 20px;">
          <table class="main" width="100%" cellpadding="0" cellspacing="0" style="box-sizing: border-box; border-radius: 3px; background-color: #fff; margin: 0; border: 1px solid #e9e9e9;" bgcolor="#fff">
            <tr style="box-sizing: border-box; margin: 0;"><td class="alert" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 21px; vertical-align: top; color: #fff; font-weight: 400; text-align: center; border-radius: 3px 3px 0 0; background-color: {{ primaryColor }}; margin: 0; padding: 13px 0 12px;" align="center" bgcolor="#FF9F00" valign="top">
              <img src="https://climber.hellocapitan.com/static/logo_white.png" class="capitan-logo"
                   width="16" height="18" style="margin-bottom:-1px">
              CAPITAN
            </td>
            </tr>
            <tr style="box-sizing: border-box; margin: 0;"><td class="content-wrap" style="vertical-align: top; margin: 0; padding: 20px;" valign="top">
              <table width="100%" cellpadding="0" cellspacing="0">

                <tr><td class="content-block" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 36px; line-height: 43px; font-weight: 300; color: #222; vertical-align: top; margin: 0; padding: 10px 10px 5px;" valign="top">
                  Join {{ accountService.getMyAccount().organization_name }} on Capitan
                </td></tr>
                <tr><td class="content-block" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; line-height:17px; font-weight: 400; color: #222; vertical-align: top; margin: 0; padding: 0px 10px 25px;" valign="top">
                  {{ accountService.getMyAccount().organization_name }} has invited you to use Capitan to manage your profile, memberships, documents, bookings and more.
                </td></tr>
                <tr style="box-sizing: border-box; margin: 0;"><td class="content-block" style="box-sizing: border-box; vertical-align: top; margin: 0; padding: 0 0 20px; text-align: center;" valign="top" align="center">
                  <a (click)="$event.preventDefault()" href="#" class="btn-primary" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; line-height: 17px; font-weight: 400; color: #FFF; text-decoration: none; text-align: center; cursor: pointer; display: inline-block; border-radius: 5px; text-transform: capitalize; background-color: {{ primaryColor }}; margin: 0; border-color: {{ primaryColor }}; border-style: solid; border-width: 10px 50px;">Join Now</a>
                </td></tr>
                <tr><td class="content-block" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; line-height:17px; font-weight: 400; color: #222; vertical-align: top; margin: 0; padding: 0px 10px 25px;" valign="top">
                  Use the links below to add your barcode to Google Wallet and Apple Wallet for easier check-in.
                </td></tr>
                <tr style="box-sizing: border-box; margin: 0;"><td class="content-block" style="box-sizing: border-box; vertical-align: top; margin: 0; padding: 0 0 20px; text-align: center;" valign="top" align="center">
                  <a (click)="$event.preventDefault()" href="#" target="_blank">
                    <img src="https://climber.hellocapitan.com/static/img/google-wallet/enUS_add_to_google_wallet_add-wallet-badge.png"
                         style="height: 40px;"
                         alt="Add to Google Wallet">
                  </a>
                  <a (click)="$event.preventDefault()" href="#" target="_blank"
                     type="application/vnd.apple.pkpass">
                    <img src="https://climber.hellocapitan.com/static/img/apple-wallet/US-UK_Add_to_Apple_Wallet_RGB_101421.png"
                         style="height: 41px;margin-bottom: -1px;"
                         alt="Add to Apple Wallet">
                  </a>
                </td></tr>

                <tr><td class="content-block" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 14px; line-height:17px; font-weight: 400; color: #222; vertical-align: top; margin: 0; padding: 0px 10px 25px;" valign="top">
                  <div [innerHtml]="getRenderedAdditionalText()"></div>
                </td></tr>

              </table>
            </td></tr>
          </table>
          <div class="footer" style="box-sizing: border-box; width: 100%; clear: both; color: #999; margin: 0; padding: 20px;">
            <table width="100%" style="box-sizing: border-box; margin: 0;"><tr style="box-sizing: border-box; margin: 0;"><td class="aligncenter content-block" style="font-family: 'Roboto', sans-serif; box-sizing: border-box; font-size: 12px; line-height: 18px; font-weight: 400; vertical-align: top; color: #999; text-align: center; margin: 0; padding: 0 0 20px;" align="center" valign="top">Made by Capitan Technologies, Inc.</td>
            </tr></table>
          </div>
        </div>
      </td>
      <td style="box-sizing: border-box; vertical-align: top; margin: 0;" valign="top"></td>
    </tr></table>

  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
